__turbopack_context__.v({
  "Animation": "admission-consultation-module__UaGRXW__Animation",
  "aboutheading1": "admission-consultation-module__UaGRXW__aboutheading1",
  "aboutparagraph1": "admission-consultation-module__UaGRXW__aboutparagraph1",
  "acheivername": "admission-consultation-module__UaGRXW__acheivername",
  "acheivernamespecial": "admission-consultation-module__UaGRXW__acheivernamespecial",
  "acheiverrank": "admission-consultation-module__UaGRXW__acheiverrank",
  "acheiverrankspecial": "admission-consultation-module__UaGRXW__acheiverrankspecial",
  "agecontent": "admission-consultation-module__UaGRXW__agecontent",
  "borderfromtabview": "admission-consultation-module__UaGRXW__borderfromtabview",
  "captcha": "admission-consultation-module__UaGRXW__captcha",
  "checkboxcontent": "admission-consultation-module__UaGRXW__checkboxcontent",
  "consult": "admission-consultation-module__UaGRXW__consult",
  "consulthover": "admission-consultation-module__UaGRXW__consulthover",
  "consultnormal": "admission-consultation-module__UaGRXW__consultnormal",
  "consultnormal1": "admission-consultation-module__UaGRXW__consultnormal1",
  "consultnormal2": "admission-consultation-module__UaGRXW__consultnormal2",
  "consultnormal3": "admission-consultation-module__UaGRXW__consultnormal3",
  "formstar": "admission-consultation-module__UaGRXW__formstar",
  "invalidCheck2": "admission-consultation-module__UaGRXW__invalidCheck2",
  "normalbutton": "admission-consultation-module__UaGRXW__normalbutton",
  "numberbold": "admission-consultation-module__UaGRXW__numberbold",
  "pagemaintitle": "admission-consultation-module__UaGRXW__pagemaintitle",
  "redunderline": "admission-consultation-module__UaGRXW__redunderline",
  "redunderlinealink": "admission-consultation-module__UaGRXW__redunderlinealink",
  "sectionredtitle": "admission-consultation-module__UaGRXW__sectionredtitle",
  "sectionsubtitle": "admission-consultation-module__UaGRXW__sectionsubtitle",
  "sectiontitle": "admission-consultation-module__UaGRXW__sectiontitle",
  "ulclass": "admission-consultation-module__UaGRXW__ulclass",
  "ulliclass": "admission-consultation-module__UaGRXW__ulliclass",
  "ullispan": "admission-consultation-module__UaGRXW__ullispan",
});
